import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import store from 'store2';
import KTComponents from 'theme-data/core';
import KTLayout from 'theme-data/app/layouts/demo1';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ChatFloatComponent } from "../common/chat-float/chat-float.component";
import { ChatFloatPatientService } from '../common/chat-float/chat-float-patient.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, SidebarComponent, ChatFloatComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements AfterViewInit, OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private router: Router,
    private renderer: Renderer2,
    private chatService: ChatFloatPatientService,
    private cdr: ChangeDetectorRef) { }

  title = 'testMC';
  chatArray: number[] = [];

  @HostBinding('class') hostClass = 'flex grow';

  ngAfterViewInit(): void {
    KTComponents.init();
    KTLayout.init();
  }

  ngOnInit(): void {
    console.log(store('FormUser'), Object.keys(store.getAll()).length === 0, !store('token'));
    if (store('FormUser') || Object.keys(store.getAll()).length === 0) {
      store(false);
      this.router.navigateByUrl('/home');
    }
    this.AddBasicClasses();

    //Chat work
    this.chatService.chatArray$.pipe(takeUntil(this.destroy$)).subscribe(c => {
      this.chatArray = c;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  removeChatFromArray(n) {
    this.chatService.removeChat(n);
  }

  logMe() {
    console.log("WOrking.");
    store.remove('token');
    const token = store('token');
    console.log('Token after removal:', token);
    this.router.navigateByUrl('/login');
  }
  AddBasicClasses() {
    this.renderer.addClass(document.body, 'antialiased');
    this.renderer.addClass(document.body, 'flex');
    this.renderer.addClass(document.body, 'h-full');
    this.renderer.addClass(document.body, 'demo1');
    this.renderer.addClass(document.body, 'sidebar-fixed');
    this.renderer.addClass(document.body, 'header-fixed');
    this.renderer.addClass(document.body, 'bg-[#fefefe]');
    this.renderer.addClass(document.body, 'dark:bg-coal-500');
  }

  trackByChatId(index: number, pId: number): number { return pId; }
}
